<template>
    <!--  <Modal-->
    <!--      v-model="_value"-->
    <!--      width="400"-->
    <!--      :closable="false"-->
    <!--      @on-visible-change="visibleChange"-->
    <!--      >-->
    <Drawer :title="installed" placement="left" v-model="_value" width="70">
        <div style="font-size: 20px;">
            <Tree :data="treeData" expand-node :render="renderContent"></Tree>

            <bsj-set-vehicle-parameters-modal v-model="bsjSetDriverCardModal" :initValue="bsjSetDriverCardId" :terminalNumValue="bsjSetDriverCardterminalNum"></bsj-set-vehicle-parameters-modal>
            <bsj-set-driver-vehicleinfo-registrationnum-modal v-model="bsjSetDriverVehicleinfoRegistrationnumModal" :initValue="bsjSetDriverVehicleinfoRegistrationnumId"></bsj-set-driver-vehicleinfo-registrationnum-modal>
            <bsj-set-mileage-modal v-model="bsjSetMileageModal" :initValue="bsjSetMileageId"></bsj-set-mileage-modal>
            <bsj-set-max-speed-modal v-model="BsjSetMaxSpeedModal" :initValue="BsjSetMaxSpeedId"></bsj-set-max-speed-modal>
            <bsj-set-g-f-viewing-screen-modal v-model="bsjSetGFViewingScreenModal" :initValue="bsjSetGFViewingScreenId"></bsj-set-g-f-viewing-screen-modal>
            <bsj-set-driver-detection-modal v-model="bsjSetDriverDetectionModal" :initValue="bsjSetDriverDetectionId"></bsj-set-driver-detection-modal>
            <hik-set-driver-card-modal v-model="hikSetDriverCardModal" :initValue="hikSetDriverCardId" :terminalNumValue="hikSetDriverCardterminalNum"></hik-set-driver-card-modal>
            <hik-set-driver-vehicleinfo-registrationnum-modal v-model="hikSetDriverVehicleinfoRegistrationnumModal" :initValue="hikSetDriverVehicleinfoRegistrationnumId"></hik-set-driver-vehicleinfo-registrationnum-modal>
            <hik-set-driver-vehicleinfo-modal v-model="hikSetDriverVehicleinfoModal" :initValue="hikSetDriverVehicleinfoId" :terminalNumValue="hikSetDriverVehicleinfoterminalNum"></hik-set-driver-vehicleinfo-modal>
            <hik-set-travel-time-modal v-model="hikSetTravelTimeModal" :initValue="hikSetTravelTimeId"></hik-set-travel-time-modal>
            <hik-set-trigger-alarm-modal v-model="hikSetTriggerAlarmModalModal" :initValue="hikSetTriggerAlarmModalId"></hik-set-trigger-alarm-modal>
            <hik-set-mileage-modal v-model="HikSetMileageModal" :initValue="HikSetMileageId"></hik-set-mileage-modal>
            <rm-set-driver-card-modal v-model="rmSetDriverCardModal" :initValue="rmSetDriverCardId" :terminalNumValue="rmSetDriverCardterminalNum"></rm-set-driver-card-modal>
            <rm-set-driver-vehicleinfo-modal v-model="rmSetDriverVehicleinfoModal" :initValue="rmSetDriverVehicleinfoId" :terminalNumValue="rmSetDriverVehicleinfoterminalNum"></rm-set-driver-vehicleinfo-modal>
            <rm-query-parameters-modal v-model="rmQueryParametersModal" :initValue="rmQueryParametersId"></rm-query-parameters-modal>
            <rm-set-driver-parameters-modal v-model="rmSetDriverParametersModal" :initValue="rmSetDriverParametersId"></rm-set-driver-parameters-modal>
            <rm-set-driver-modal v-model="rmSetDriverModal" :initValue="rmSetDriverId"></rm-set-driver-modal>
            <rm-set-driver-i-p-modal v-model="rmSetDriverIPModal"  :initValue="rmSetDriverIPId"></rm-set-driver-i-p-modal>
            <rm-set-trigger-alarm-modal v-model="rmSetTriggerAlarmModal" :initValue="rmSetTriggerAlarmId"></rm-set-trigger-alarm-modal>
            <rm-set-close-s-i-m-lock-modal v-model="rmSetCloseSIMLockModal" :initValue="rmSetCloseSIMLockId"></rm-set-close-s-i-m-lock-modal>
            <zt-set-driver-card-modal  v-model="ztSetDriverCardModal" :initValue="ztSetDriverCardId" :terminalNumValue="ztSetDriverCardterminalNum"></zt-set-driver-card-modal>
            <zt-set-driver-vehicleinfo-modal  v-model="ztSetDriverVehicleinfoModal" :initValue="ztSetDriverVehicleinfoId" :terminalNumValue="ztSetDriverVehicleinfoterminalNum"></zt-set-driver-vehicleinfo-modal>
            <zt-set-driver-speed-alarm-modal v-model="ztSetDriverSpeedAlarmModal" :initValue="ztSetDriverSpeedAlarmId"></zt-set-driver-speed-alarm-modal>
            <zt-set-disk-formatting-modal v-model="ztSetDiskFormattingModal" :initValue="ztSetDiskFormattingId"></zt-set-disk-formatting-modal>
            <zt-set-driver-mileage-modal v-model="ztSetDriverMileageModal" :initValue="ztSetDriverMileageId"></zt-set-driver-mileage-modal>
            <zt-set-driver-restart-modal v-model="ztSetDriverRestartModal" :initValue="ztSetDriverRestartId"></zt-set-driver-restart-modal>
            <zt-set-driver-adas-alarm-modal v-model="ztSetDriverAdasAlarmModal" :initValue="ztSetDriverAdasAlarmId"></zt-set-driver-adas-alarm-modal>
            <zt-set-driver-dsm-alarm-modal v-model="ztSetDriverDsmAlarmModal" :initValue="ztSetDriverDsmAlarmId"></zt-set-driver-dsm-alarm-modal>
            <zt-set-driver-alarm-enablel-modal v-model="ztSetDriverAlarmEnablelModal" :initValue="ztSetDriverAlarmEnablelId"></zt-set-driver-alarm-enablel-modal>
            <zt-set-test-pattern-modal v-model="ztSetTestPatternModal" :initValue="ztSetTestPatternId"></zt-set-test-pattern-modal>
            <tl-set-driver-card-modal v-model="tlSetDriverCardModal" :initValue="tlSetDriverCardId" :terminalNumValue="tlSetDriverCardterminalNum"></tl-set-driver-card-modal>
            <tl-set-driver-vehicleinfo-modal v-model="tlSetDriverVehicleinfoModal" :initValue="tlSetDriverVehicleinfoId" :terminalNumValue="tlSetDriverVehicleinfoterminalNum"></tl-set-driver-vehicleinfo-modal>
            <tl-set-hard-disk-slarm-modal v-model="tlSetHardDiskSlarmModal" :initValue="tlSetHardDiskSlarmId" :terminalNumValue="tlSetHardDiskSlarmterminalNum"></tl-set-hard-disk-slarm-modal>
        </div>
    </Drawer>
</template>
<script>
    import BsjSetVehicleParametersModal from '@/views/ddm/components/bsj-set-vehicle-parameters-modal'
    import BsjSetDriverVehicleinfoRegistrationnumModal from '@/views/ddm/components/bsj-set-driver-vehicleinfo-registrationnum-modal'
    import BsjSetMileageModal from '@/views/ddm/components/bsj-set-mileage-modal'
    import BsjSetMaxSpeedModal from '@/views/ddm/components/bsj-set-max-speed-modal'
    import BsjSetGFViewingScreenModal from '@/views/ddm/components/bsj-set-GF-viewing-screen-modal'
    import BsjSetDriverDetectionModal from '@/views/ddm/components/bsj-set-driver-detection-modal'
    import HikSetDriverCardModal from '@/views/ddm/components/hik-set-driver-card-modal'
    import HikSetDriverVehicleinfoModal from '@/views/ddm/components/hik-set-driver-vehicleinfo-modal'
    import HikSetDriverVehicleinfoRegistrationnumModal from '@/views/ddm/components/hik-set-driver-vehicleinfo-registrationnum-modal'
    import HikSetTravelTimeModal from '@/views/ddm/components/hik-set-travel-time-modal'
    import HikSetTriggerAlarmModal from '@/views/ddm/components/hik-set-trigger-alarm-modal'
    import HikSetMileageModal from '@/views/ddm/components/hik-set-mileage-modal'
    import RmSetDriverCardModal from '@/views/ddm/components/rm-set-driver-card-modal'
    import RmSetDriverVehicleinfoModal from '@/views/ddm/components/rm-set-driver-vehicleinfo-modal'
    import RmQueryParametersModal from '@/views/ddm/components/rm-query-parameters-modal'
    import RmSetDriverParametersModal from '@/views/ddm/components/rm-set-driver-parameters-modal'
    import RmSetDriverModal from '@/views/ddm/components/rm-set-driver-modal'
    import RmSetDriverIPModal from '@/views/ddm/components/rm-set-driver-ip-modal'
    import RmSetTriggerAlarmModal from '@/views/ddm/components/rm-set-trigger-alarm-modal'
    import RmSetCloseSIMLockModal from '@/views/ddm/components/rm-set-close-SIM-lock-modal'
    import ZtSetDriverCardModal from '@/views/ddm/components/zt-set-driver-card-modal'
    import ZtSetDriverVehicleinfoModal from '@/views/ddm/components/zt-set-driver-vehicleinfo-modal'
    import ZtSetDriverSpeedAlarmModal from '@/views/ddm/components/zt-set-driver-speed-alarm-modal'
    import ZtSetDiskFormattingModal from '@/views/ddm/components/zt-set-disk-formatting-modal'
    import ZtSetDriverMileageModal from '@/views/ddm/components/zt-set-driver-mileage-modal'
    import ZtSetDriverRestartModal from '@/views/ddm/components/zt-set-driver-restart-modal'
    import ZtSetDriverAdasAlarmModal from '@/views/ddm/components/zt-set-driver-adas-alarm-modal'
    import ZtSetDriverDsmAlarmModal from '@/views/ddm/components/zt-set-driver-dsm-alarm-modal'
    import ZtSetDriverAlarmEnablelModal from '@/views/ddm/components/zt-set-driver-alarm-enablel-modal'
    import ZtSetTestPatternModal from '@/views/ddm/components/zt-set-test-pattern-modal'
    import TlSetDriverCardModal from '@/views/ddm/components/tl-set-driver-card-modal'
    import TlSetDriverVehicleinfoModal from '@/views/ddm/components/tl-set-driver-vehicleinfo-modal'
    import TlSetHardDiskSlarmModal from '@/views/ddm/components/tl-set-hard-disk-alarm-modal'

    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

    export default {
        name: 'selectsendcommandmodal',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null,
            installed: null
        },
        components: {
            BsjSetVehicleParametersModal,
            BsjSetDriverVehicleinfoRegistrationnumModal,
            BsjSetMileageModal,
            BsjSetMaxSpeedModal,
            BsjSetGFViewingScreenModal,
            BsjSetDriverDetectionModal,
            HikSetDriverCardModal,
            HikSetDriverVehicleinfoModal,
            HikSetDriverVehicleinfoRegistrationnumModal,
            HikSetTravelTimeModal,
            HikSetTriggerAlarmModal,
            HikSetMileageModal,
            RmSetDriverCardModal,
            RmSetDriverVehicleinfoModal,
            RmQueryParametersModal,
            RmSetDriverParametersModal,
            RmSetDriverModal,
            RmSetDriverIPModal,
            RmSetTriggerAlarmModal,
            RmSetCloseSIMLockModal,
            ZtSetDriverCardModal,
            ZtSetDriverVehicleinfoModal,
            ZtSetDriverSpeedAlarmModal,
            ZtSetDiskFormattingModal,
            ZtSetDriverMileageModal,
            ZtSetDriverRestartModal,
            ZtSetDriverAdasAlarmModal,
            ZtSetDriverDsmAlarmModal,
            ZtSetDriverAlarmEnablelModal,
            ZtSetTestPatternModal,
            TlSetDriverCardModal,
            TlSetDriverVehicleinfoModal,
            TlSetHardDiskSlarmModal,
        },
        data() {
            return {


                // Bsj设置司机卡
                bsjSetDriverCardModal: false,
                bsjSetDriverCardId: null,
                bsjSetDriverCardterminalNum: null,

                // Bsj设置车牌号
                bsjSetDriverVehicleinfoRegistrationnumModal: false,
                bsjSetDriverVehicleinfoRegistrationnumId: null,

                // Bsj设置里程
                bsjSetMileageModal: false,
                bsjSetMileageId: null,

                //设置限速阀值
                BsjSetMaxSpeedModal:false,
                BsjSetMaxSpeedId:null,

                // 设置倒车大屏
                bsjSetGFViewingScreenModal:false,
                bsjSetGFViewingScreenId:null,

                //博实结关闭驾驶员检测
                bsjSetDriverDetectionModal:false,
                bsjSetDriverDetectionId:null,

                // Hik设置司机卡
                hikSetDriverCardModal: false,
                hikSetDriverCardId: null,
                hikSetDriverCardterminalNum: null,

                // Hik设置车牌号
                hikSetDriverVehicleinfoRegistrationnumModal:false,
                hikSetDriverVehicleinfoRegistrationnumId:null,

                // Hik设置设置夜间行驶时长
                hikSetTravelTimeModal: false,
                hikSetTravelTimeId: null,

                //Hik触发设备报警
                hikSetTriggerAlarmModalModal:false,
                hikSetTriggerAlarmModalId:null,

                // Hik设置车辆参数
                hikSetDriverVehicleinfoModal:false,
                hikSetDriverVehicleinfoId:null,
                hikSetDriverVehicleinfoterminalNum:null,

                // Hik设置行驶里程
                HikSetMileageModal: false,
                HikSetMileageId: null,

                // Rm设置司机卡
                rmSetDriverCardModal: false,
                rmSetDriverCardId: null,
                rmSetDriverCardterminalNum: null,

                //Rm设置车辆参数
                rmSetDriverVehicleinfoModal: false,
                rmSetDriverVehicleinfoId: null,
                rmSetDriverVehicleinfoterminalNum: null,

                //锐明查询车辆参数
                rmQueryParametersModal:false,
                rmQueryParametersId:null,

                // 锐明设置参数
                rmSetDriverParametersModal: false,
                rmSetDriverParametersId: null,

                // 锐明设置车辆协议
                rmSetDriverModal:false,
                rmSetDriverId:null,

                //锐明设置IP
                rmSetDriverIPModal:false,
                rmSetDriverIPId:null,

                //锐明触发报警
                rmSetTriggerAlarmModal:false,
                rmSetTriggerAlarmId:null,

                // 锐明关闭SIM卡锁
                rmSetCloseSIMLockModal: false,
                rmSetCloseSIMLockId: null,

                //中天安驰设置司机卡
                ztSetDriverCardModal:false,
                ztSetDriverCardId:null,
                ztSetDriverCardterminalNum: null,

                //中天安驰设置司机卡
                ztSetDriverVehicleinfoModal:false,
                ztSetDriverVehicleinfoId:null,
                ztSetDriverVehicleinfoterminalNum:null,

                //中天安驰设置速度报警
                ztSetDriverSpeedAlarmModal:false,
                ztSetDriverSpeedAlarmId:null,

                //中天安驰磁盘格式化
                ztSetDiskFormattingModal:false,
                ztSetDiskFormattingId:null,

                //中天安驰设置里程
                ztSetDriverMileageModal:false,
                ztSetDriverMileageId:null,

                //中天安驰重启控制
                ztSetDriverRestartModal:false,
                ztSetDriverRestartId:null,

                //中天安驰设置ADAS报警
                ztSetDriverAdasAlarmModal:false,
                ztSetDriverAdasAlarmId:null,

                //中天安驰设置DSM报警
                ztSetDriverDsmAlarmModal:false,
                ztSetDriverDsmAlarmId:null,

                //中天安驰报警使能
                ztSetDriverAlarmEnablelModal:false,
                ztSetDriverAlarmEnablelId:null,

                //中天安驰测试模式
                ztSetTestPatternModal:false,
                ztSetTestPatternId:null,

                // 通立设置司机卡
                tlSetDriverCardModal: false,
                tlSetDriverCardId: null,
                tlSetDriverCardterminalNum: null,

                // 通立设置车辆参数
                tlSetDriverVehicleinfoModal: false,
                tlSetDriverVehicleinfoId: null,
                tlSetDriverVehicleinfoterminalNum: null,

                //通立设置存储报警
                tlSetHardDiskSlarmModal: false,
                tlSetHardDiskSlarmId: null,
                tlSetHardDiskSlarmterminalNum: null,

                vehicleInfo: {
                    identificationCode: null
                },
                installOrder: {},

                treeData: [
                    {
                        title: '博实结',
                        expand: true,
                        children: [//index：0
                            {
                                title: '博实结采集车辆信息',
                            },
                            {
                                title: '博实结设置车牌',
                            },
                            {
                                title: '博实结设置里程',
                            },
                            {
                                title: '博实结设置车辆参数',
                            },
                            {
                                title: '博实结设置限速',
                            },
                            {
                                title: '博实结设置倒车大屏',
                            }
                            ,
                            {
                                title: '博实结关闭驾驶员检测',
                            }
                        ]
                    },
                    {
                        title: '海康',
                        expand: true,
                        children: [//index：5
                            {
                                title: '海康写卡',
                            },
                            {
                                title: '海康设置车牌号',
                            },
                            {
                                title: '海康设置车辆参数',
                            },
                            {
                                title: '海康设置行驶里程',
                            },
                            {
                                title: '海康设置夜间行驶时长',
                            },
                            // {
                            //     title: '采集设备信息',
                            // },
                            {
                                title: '海康触发报警',
                            },
                        ]
                    },
                    {
                        title: '锐明',
                        expand: true,
                        children: [//index：10
                            {
                                title: '锐明写卡',
                            },
                            {
                                title: '锐明设置车辆参数',
                            },
                            {
                                title: '锐明设置参数',
                            },
                            {
                                title: '锐明设置协议',
                            },
                            // {
                            //     title: '锐明设置IP',
                            // },
                            // {
                            //     title: '采集车辆信息',
                            // },
                            // {
                            //     title: '锐明触发报警（粤标）',
                            // },
                            {
                                title: '锐明关闭SIM卡锁',
                            },
                        ]
                    },
                    {
                        title: '中天安驰',
                        expand: true,
                        children: [//index：17
                            {
                                title: '中天安驰写卡',
                            },
                            {
                                title: '中天安驰设置车辆参数',
                            },
                            {
                                title: '中天安驰设置速度报警',
                            },
                            {
                                title: '中天安驰磁盘格式化',
                            },
                            {
                                title: '中天安驰设置里程',
                            },
                            {
                                title: '中天安驰重启控制',
                            },
                            {
                                title: '中天安驰ADAS报警',
                            },
                            {
                                title: '中天安驰DSM报警',
                            },
                            {
                                title: '中天安驰报警使能',
                            },
                            {
                                title: '中天测试模式',
                            },
                        ]
                    },
                    {
                        title: '通立',
                        expand: true,
                        children: [//index：5
                            {
                                title: '通立写卡',
                            },
                            {
                                title: '通立设置车辆参数',
                            },
                            {
                                title: '通立设置存储报警',
                            },
                        ]
                    },
                    {
                        title: '通用',
                        expand: true,
                        children: [//27
                            {
                                title: '采集车牌号',
                            },
                            {
                                title: '采集驾驶员身份证',
                            },
                            {
                                title: '采集设备信息',
                            },
                        ]
                    },
                ]

            }
        },
        methods: {
            ...mapActions([]),
            visibleChange(val) {
                if (val) {
                    this._initValue
                }
            },
            renderContent(h, { root, node, data }){
                return h('span',{
                    style:{
                        color:'#666',
                        cursor:'pointer',
                        fontSize:'20px'
                    },
                    domProps:{
                        className:'btn'
                    },
                    on:{
                        click:(e)=>{
                            //用nodeKey调用方法
                            console.log(data)
                            console.log(data.nodeKey)
                            console.log(this._initValue)//jt808,id

                            /*博实结*/
                            // 采集车辆信息
                            if (data.title == '博实结采集车辆信息') {
                                store.dispatch('NetCommandServ_SendCommand', {
                                    params: { id: this._initValue, content: '<EXTBE0>', urgent: true }
                                }).then(() => {
                                    this.$Message.success('采集车辆信息，发送成功')
                                }).catch(err => {
                                    this.$Message.error(err)
                                })
                            }
                            // 设置车牌
                            if (data.title == '博实结设置车牌') {
                                this.bsjSetDriverVehicleinfoRegistrationnumModal = true
                                this.bsjSetDriverVehicleinfoRegistrationnumId = this._initValue
                            }
                            // 设置里程
                            if (data.title == '博实结设置里程') {
                                this.bsjSetMileageModal = true
                                this.bsjSetMileageId = this._initValue
                            }
                            // 设置车辆参数
                            if (data.title == '博实结设置车辆参数') {
                                this.bsjSetDriverCardModal = true
                                this.bsjSetDriverCardId = this._initValue
                                this.bsjSetDriverCardterminalNum = this._installed
                            }
                            // 设置限速
                            if (data.title == '博实结设置限速') {
                                this.BsjSetMaxSpeedModal = true
                                this.BsjSetMaxSpeedId = this._initValue
                            }
                            //设置倒车大屏
                            if (data.title == '博实结设置倒车大屏') {
                                this.bsjSetGFViewingScreenModal = true
                                this.bsjSetGFViewingScreenId = this._initValue
                            }
                            //博实结设置关闭驾驶员检测
                            if (data.title == '博实结关闭驾驶员检测') {
                                this.bsjSetDriverDetectionModal = true
                                this.bsjSetDriverDetectionId = this._initValue
                            }

                            /*海康*/
                            //写卡
                            if (data.title == '海康写卡') {
                                this.hikSetDriverCardModal = true
                                this.hikSetDriverCardId = this._initValue
                                this.hikSetDriverCardterminalNum = this._installed
                            }
                            // 设置车牌号
                            if (data.title == '海康设置车牌号') {
                                this.hikSetDriverVehicleinfoRegistrationnumModal = true
                                this.hikSetDriverVehicleinfoRegistrationnumId = this._initValue
                            }
                            //设置车辆参数
                            if (data.title == '海康设置车辆参数') {
                                this.hikSetDriverVehicleinfoModal = true
                                this.hikSetDriverVehicleinfoId = this._initValue
                                this.hikSetDriverVehicleinfoterminalNum = this._installed
                            }
                            //设置行驶里程
                            if (data.title == '海康设置行驶里程') {
                                this.HikSetMileageModal = true
                                this.HikSetMileageId = this._initValue
                            }
                            // 设置夜间行驶时长
                            if (data.title == '海康设置夜间行驶时长') {
                                this.hikSetTravelTimeModal = true
                                this.hikSetTravelTimeId = this._initValue
                            }
                            // 海康触发报警
                            if (data.title == '海康触发报警') {
                                this.hikSetTriggerAlarmModalModal = true
                                this.hikSetTriggerAlarmModalId = this._initValue
                            }
                            // //采集设备信息
                            // if (data.title == 10) {
                            // }

                            /*锐明*/
                            //写卡
                            if (data.title == '锐明写卡') {
                                this.rmSetDriverCardModal = true
                                this.rmSetDriverCardId = this._initValue
                                this.rmSetDriverCardterminalNum = this._installed
                            }
                            // 设置车辆参数
                            if (data.title == '锐明设置车辆参数') {
                                this.rmSetDriverVehicleinfoModal = true
                                this.rmSetDriverVehicleinfoId = this._initValue
                                this.rmSetDriverVehicleinfoterminalNum = this._installed
                            }
                            //设置参数
                            if (data.title == '锐明设置参数') {
                                this.rmSetDriverParametersModal = true
                                this.rmSetDriverParametersId = this._initValue
                            }
                            // 设置协议
                            if (data.title == '锐明设置协议') {
                                this.rmSetDriverModal = true
                                this.rmSetDriverId = this._initValue
                            }
                            // 设置IP
                            if (data.title == '锐明设置IP') {
                                this.rmSetDriverIPModal = true
                                this.rmSetDriverIPId = this._initValue
                            }
                            // 锐明触发报警
                            if (data.title == '锐明触发报警（粤标）') {
                                this.rmSetTriggerAlarmModal = true
                                this.rmSetTriggerAlarmId = this._initValue
                            }
                            // 锐明触发报警
                            if (data.title == '锐明关闭SIM卡锁') {
                                this.rmSetCloseSIMLockModal = true
                                this.rmSetCloseSIMLockId = this._initValue
                            }

                            /*中天安驰*/
                            //写卡
                            if (data.title == '中天安驰写卡') {
                                this.ztSetDriverCardModal = true
                                this.ztSetDriverCardId = this._initValue
                                this.ztSetDriverCardterminalNum = this._installed
                            }
                            // 设置车辆参数
                            if (data.title == '中天安驰设置车辆参数') {
                                this.ztSetDriverVehicleinfoModal = true
                                this.ztSetDriverVehicleinfoId = this._initValue
                                this.ztSetDriverVehicleinfoterminalNum = this._installed
                            }
                            //设置速度报警
                            if (data.title == '中天安驰设置速度报警') {
                                this.ztSetDriverSpeedAlarmModal = true
                                this.ztSetDriverSpeedAlarmId = this._initValue
                            }
                            // 磁盘格式化
                            if (data.title == '中天安驰磁盘格式化') {
                                this.ztSetDiskFormattingModal = true
                                this.ztSetDiskFormattingId = this._initValue
                            }
                            // 设置里程
                            if (data.title == '中天安驰设置里程') {
                                this.ztSetDriverMileageModal = true
                                this.ztSetDriverMileageId = this._initValue
                            }
                            // 重启控制
                            if (data.title == '中天安驰重启控制') {
                                this.ztSetDriverRestartModal = true
                                this.ztSetDriverRestartId = this._initValue
                            }
                            // ADAS报警
                            if (data.title == '中天安驰ADAS报警') {
                                this.ztSetDriverAdasAlarmModal = true
                                this.ztSetDriverAdasAlarmId = this._initValue
                            }
                            //DSM报警
                            if (data.title == '中天安驰DSM报警') {
                                this.ztSetDriverDsmAlarmModal = true
                                this.ztSetDriverDsmAlarmId = this._initValue
                            }
                            //报警使能
                            if (data.title == '中天安驰报警使能') {
                                this.ztSetDriverAlarmEnablelModal = true
                                this.ztSetDriverAlarmEnablelId = this._initValue
                            }
                            //中天安驰测试模式
                            if (data.title == '中天测试模式') {
                                this.ztSetTestPatternModal = true
                                this.ztSetTestPatternId = this._initValue
                            }

                            /*通立安驰*/
                            //写卡
                            if (data.title == '通立写卡') {
                                this.tlSetDriverCardModal = true
                                this.tlSetDriverCardId = this._initValue
                                this.tlSetDriverCardterminalNum = this._installed
                            }
                            // 设置车辆参数
                            if (data.title == '通立设置车辆参数') {
                                this.tlSetDriverVehicleinfoModal = true
                                this.tlSetDriverVehicleinfoId = this._initValue
                                this.tlSetDriverVehicleinfoterminalNum = this._installed
                            }
                            // 设置存储报警
                            if (data.title == '通立设置存储报警') {
                                this.tlSetHardDiskSlarmModal = true
                                this.tlSetHardDiskSlarmId = this._initValue
                                this.tlSetHardDiskSlarmterminalNum = this._installed
                            }

                            /*通用*/
                            //采集车牌号
                            if (data.title == '采集车牌号') {
                            }
                            // 采集驾驶员身份证
                            if (data.title == '采集驾驶员身份证') {
                            }
                            //采集设备信息
                            if (data.title == '采集设备信息') {
                            }
                        }
                    }
                },data.title)
            }

        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _installed: {
                get() {
                    return this.installed
                },
                set(val) {
                    // this.$emit('input', val)
                    // this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            },
        },
        mounted() {
            this.$nextTick(() => {

            })
        }
    }
</script>
<style>
    .demo-split {
        height: 500px;
        border: 1px solid #dcdee2;
    }

    .demo-split-pane {
        padding: 10px;
    }
</style>
